import { Button, ButtonColor, ButtonType, ButtonWithIcon } from '@oy/ui';
import { IconName } from '@oy/uiicon';
import React from 'react';
import { useUITranslate } from '../../../../hooks/useUITranslate';
import styles from './Footer.module.css';

export type CreationLayoutFooter = {
  children?: React.ReactNode;
  nextButtonText?: string;
  nextButtonOnClick?: () => void;
  nextButtonType?: ButtonType;
  nextButtonColor?: ButtonColor;
  backButtonText?: string;
  backButtonOnClick?: () => void;
  backButtonType?: ButtonType;
  backButtonColor?: ButtonColor;
  backButtonIcon?: IconName;
};

const Footer = ({
  children,
  nextButtonText,
  nextButtonOnClick,
  nextButtonType = Button.Type.Filled,
  nextButtonColor,
  backButtonText,
  backButtonOnClick,
  backButtonType = Button.Type.Text,
  backButtonColor = Button.Color.Secondary,
  backButtonIcon = 'back',
}: CreationLayoutFooter) => {
  const { translate } = useUITranslate();
  return (
    <div className={styles.footer}>
      <div className={styles.footerMain}>
        <div className={styles.left}>
          {backButtonText && backButtonOnClick && (
            <>
              {!!backButtonIcon ? (
                <ButtonWithIcon
                  iconName={backButtonIcon}
                  buttonType={backButtonType}
                  color={backButtonColor}
                  onClick={backButtonOnClick}
                >
                  {backButtonText}
                </ButtonWithIcon>
              ) : (
                <Button
                  buttonType={
                    (backButtonType as ButtonType) ?? Button.Type.Text
                  }
                  color={
                    (backButtonColor as ButtonColor) ?? Button.Color.Secondary
                  }
                  onClick={backButtonOnClick}
                >
                  {backButtonText ?? translate('Back')}
                </Button>
              )}
            </>
          )}
        </div>
        <div className={styles.right}>
          {children}
          {nextButtonText && nextButtonOnClick && (
            <Button
              buttonType={nextButtonType}
              color={nextButtonColor}
              onClick={nextButtonOnClick}
            >
              {nextButtonText ?? translate('Next')}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default Footer;
